import { observer } from "mobx-react-lite";
import React from "react";

const ItemEmployee = observer(({ employee }) => {
  const roleLabel =
    employee.role_rel !== null && employee.role_rel !== undefined
      ? employee.role_rel.role_name
      : "Роль не назначена";
  const roleMuted =
    employee.role_rel === null || employee.role_rel === undefined;

  return (
    <>
      <span className="reports-cell" title={employee.last_name ?? ""}>
        {employee.last_name}
      </span>
      <span className="reports-cell" title={employee.first_name ?? ""}>
        {employee.first_name}
      </span>
      <span className="reports-cell employees-list-col-patronymic" title={employee.father_name ?? ""}>
        {employee.father_name}
      </span>
      <span
        className="reports-cell company-card-v4-mono employees-list-col-email"
        title={employee.email ?? ""}
      >
        {employee.email}
      </span>
      <span
        className="reports-cell company-card-v4-mono employees-list-col-phone"
        title={employee.phone ?? ""}
      >
        {employee.phone}
      </span>
      <span
        className={`reports-cell employees-list-col-role${
          roleMuted ? " reports-cell-muted" : ""
        }`}
        title={roleLabel}
      >
        {roleLabel}
      </span>
    </>
  );
});

export default ItemEmployee;
